var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlagiarism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4C2.9 0 2.01 0.9 2.01 2L2 18C2 19.1 2.89 20 3.99 20H16C17.1 20 18 19.1 18 18V6L12 0ZM4 2H11L16 7V15.58L14.16 13.74C15.44 11.8 15.23 9.17 13.52 7.46C12.55 6.49 11.28 6 10 6C8.72 6 7.45 6.49 6.47 7.46C4.52 9.41 4.52 12.57 6.47 14.51C7.44 15.48 8.72 15.97 10 15.97C10.96 15.97 11.92 15.69 12.75 15.14L15.6 18H4V2ZM12.11 13.1C11.55 13.66 10.8 13.98 10 13.98C9.2 13.98 8.45 13.67 7.89 13.1C7.33 12.54 7.01 11.79 7.01 10.99C7.01 10.19 7.32 9.44 7.89 8.88C8.45 8.31 9.2 8 10 8C10.8 8 11.55 8.31 12.11 8.88C12.67 9.44 12.99 10.19 12.99 10.99C12.99 11.79 12.68 12.54 12.11 13.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlagiarism);
export default __webpack_public_path__ + "static/media/plagiarism.10fe654851d6616d215584ce0ab8a1fc.svg";
export { ForwardRef as ReactComponent };